<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Time Change for Ride</span>
      <span class="text-light-color text-base font-normal">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<app-tabs [initialTabIndex]="0">
  <app-tab tabTitle="Stops Overview">
    <p-dialog
      [showHeader]="false"
      [modal]="true"
      [(visible)]="changeTimeDialogvisible"
      [style]="{ width: '400px' }">
      <div class="p-dialog-header px-0">
        <div class="p-dialog-title">
          <div class="flex gap-spacing-xs align-items-center">
            <span class="title-small-bold text-primary-color">Anchor Stop Time Change</span>
          </div>
        </div>
        <div class="p-dialog-header-icons">
          <app-button
            (btnClick)="closeTimeDialog()"
            [iconOnlyButton]="true"
            icon="icon-x"
            sizeClass="p-button-sm"
            severity="secondary"
            [textButton]="true"></app-button>
        </div>
      </div>

      <div class="flex flex-column gap-spacing-xl">
        <div class="grid">
          <div class="col-6">
            <div class="time-card flex gap-spacing-3xs flex-column border-1 form-border-default-border border-round-md bg-white w-full py-spacing-xs px-spacing-md">
              <span class="text-sm font-medium text-caption-color">Current Arrival Time</span>
              <span class="label-large-medium text-secondary-color">{{ currentArrivalTime }}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="time-card flex gap-spacing-3xs flex-column border-1 form-border-default-border border-round-md bg-white w-full py-spacing-xs px-spacing-md">
              <span class="text-sm font-medium text-caption-color">New Arrival Time</span>
              <span class="label-large-medium text-secondary-color">{{ newArrivalTime }}</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            class="input-label label-large-medium text-secondary-color mb-spacing-default"
            for="arrivalTimeAdjustment"
            >Adjust By</label
          >
          <div class="k-input-wrapper">
            <p-inputNumber
              class="w-full p-inputtext-sm"
              #arrivalTimeAdjustmentInp="ngModel"
              [(ngModel)]="arrivalTimeAdjustment"
              name="arrivalTimeAdjustment"
              inputId="arrivalTimeAdjustment"
              required
              (onBlur)="reflectTime()"
              [style]="{ width: '100%' }" />
            <em class="right-icon">Min</em>
          </div>
          @if (arrivalTimeAdjustmentInp.dirty && arrivalTimeAdjustmentInp.errors && arrivalTimeAdjustmentInp.errors["required"]) {
            <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
          }
        </div>
      </div>

      <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
        <app-button
          label="Close"
          (btnClick)="closeTimeDialog()"
          sizeClass="p-button-md"
          severity="secondary">
        </app-button>
        <app-button
          label="Apply"
          [disabled]="loading || !arrivalTimeAdjustmentInp?.valid"
          (btnClick)="applyTime()"
          sizeClass="p-button-md"
          severity="primary"></app-button>
      </div>
    </p-dialog>
    <div class="stops-overview-section">
      <h6 class="text-sm font-medium">Stops</h6>
      <div class="stops-section">
        @for (stop of config.data.rideStops; let i = $index; track $index) {
          <div class="stop mb-3 w-full flex justify-content-between gap-spacing-xl align-items-start">
            <div class="left flex flex-grow-1 gap-spacing-md align-items-start">
              <div class="time flex flex-column align-items-center gap-spacing-default">
                @if ((config.data.rideType.toLowerCase() == rideType().outbound && i == config.data.rideStops.length - 1) || (config.data.rideType.toLowerCase() == rideType().return && i == 0)) {
                  <span
                    (click)="openTimeDialog()"
                    (keydown.enter)="openTimeDialog()"
                    class="text-sm font-medium text-link-color cursor-pointer"
                    >{{ stop.time }}</span
                  >
                } @else {
                  <span class="text-sm font-medium text-secondary-color">{{ stop.time }}</span>
                }
                <span class="text-xs font-medium text-light-color">{{ config.data.rideTimezone }}</span>
              </div>
              <div class="badge-container relative">
                <app-badge
                  [value]="(i + 1).toString()"
                  size="xlarge"
                  severityClass="info"></app-badge>
              </div>

              <div
                style="min-width: 420px"
                class="flex gap-spacing-xl border-1 border-neutral-base-primary-border border-round-md bg-white w-full py-spacing-xs px-spacing-md">
                <span class="h-line"></span>
                <div class="location pr-spacing-xl border-right-1 border-neutral-base-primary-border w-6">
                  <div class="place flex align-items-center gap-spacing-xs">
                    @if (stop.placeType == "School") {
                      <i class="icon-building-office-solid text-base text-lightest-color"></i>
                    } @else {
                      <img
                        src="assets/images/house-5 1.svg"
                        alt="" />
                    }
                    <span class="name text-sm font-medium text-secondary-color">{{ stop.place }}</span>
                  </div>
                  <div class="map-location flex align-items-center gap-spacing-xs">
                    <i class="icon-map-pin-solid text-md text-link-color"></i>
                    <a class="link text-sm font-normal text-link-color no-underline">{{ stop.address }}</a>
                  </div>
                </div>

                <div class="passengers w-6">
                  <h6 class="text-sm font-medium mb-spacing-default text-secondary-color">Passengers</h6>
                  <div class="grid grid-nogutter gap-spacing-xs">
                    @for (passenger of stop.cargoes; track $index) {
                      <div class="passenger w-full bg-white flex flex-column gap-spacing-xs">
                        <div class="flex justify-content-between gap-spacing-xs">
                          <div class="left flex align-items-center gap-spacing-xs">
                            <i class="icon-user-plus-solid text-md form-placeholder-color"></i>
                            <span class="name text-sm font-medium line-height-3 text-secondary-color">{{ passenger.name }}</span>
                            <app-tag
                              class="hidden xl:block"
                              [content]="passenger.type"
                              sizeClass="tag-sm"
                              severityClass="secondary"></app-tag>
                            <i
                              class="text-lg hidden xl:block"
                              [pTooltip]="passenger.isTransportationConfirmed ? 'Transportaion Confirmed' : 'Needs Confirmation'"
                              tooltipPosition="bottom"
                              [autoHide]="false"
                              [ngClass]="{
                                'icon-check-circle-solid icon-success-subtle-color': passenger.isTransportationConfirmed,
                                'icon-question-solid icon-warning-color': !passenger.isTransportationConfirmed
                              }"></i>
                          </div>

                          <div class="right flex justify-content-between align-items-center">
                            <app-tag
                              [content]="passenger.actionType"
                              sizeClass="tag-sm"
                              styleClass="bold"
                              severityClass="secondary"></app-tag>
                          </div>
                        </div>

                        <div class="flex align-items-center gap-spacing-xs">
                          <app-tag
                            class="block xl:hidden"
                            [content]="passenger.type"
                            sizeClass="tag-sm"
                            severityClass="secondary"></app-tag>
                          <i
                            class="text-lg block xl:hidden"
                            [pTooltip]="passenger.isTransportationConfirmed ? 'Transportaion Confirmed' : 'Needs Confirmation'"
                            tooltipPosition="bottom"
                            [autoHide]="false"
                            [ngClass]="{
                              'icon-check-circle-solid icon-success-subtle-color': passenger.isTransportationConfirmed,
                              'icon-question-solid icon-warning-color': !passenger.isTransportationConfirmed
                            }"></i>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="form-group flex flex-column gap-spacing-xs">
      <label
        class="input-label flex flex-column gap-spacing-default body-medium-medium"
        for="reasonInput"
        >Reason
        <span class="body-small-medium form-placeholder-color">The reason for why you are changing the ride’s time.</span>
      </label>
      <p-autoComplete
        #reasonInput="ngModel"
        #autoCompleteRef
        [(ngModel)]="reason"
        required
        [suggestions]="filteredSuggestions"
        (completeMethod)="filterSuggestions($event, autoCompleteRef)"
        (onFocus)="filterSuggestions($event, autoCompleteRef)"
        [showEmptyMessage]="false"
        appendTo="body"
        [style]="{ width: '100%' }"
        [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
        placeholder="Select or enter a reason." />
    </div>
  </app-tab>
</app-tabs>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    label="Change Time"
    [isLoading]="loading"
    [disabled]="loading || !reasonInput?.valid || reasonInput.value?.trim().length <= 0"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="primary">
  </app-button>
</div>
